import { ChartHeatmapDataItem } from 'src/app/shared/chart/chart.models';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { buildDailyChartData } from '../../vehicle-fingerprint.utils';

export function buildDailyActivityData(context: VehicleFingerprintContext): ChartHeatmapDataItem[] {
  const dates = context.dates || [];
  const quality = new Map((context.dailyQuality || [])
    .filter(row => typeof row?.dtDate === 'string')
    .map(row => [row.dtDate.slice(0, 10), row] as const));
  const data = buildDailyChartData(context.dailyActivity || [], dates, row => {
    const value = row.fDailyMovingHours;
    return row.iRecordCount > 0 && typeof value === 'number'
      && Number.isFinite(value) && value >= 0 && value <= 24 ? value : null;
  });
  return data.map((item, index) => {
    const row = quality.get(dates[index]);
    const details = [
      describeFlag(row?.bInsideBaselineWindow, 'بازهٔ مرجع', 'داخل', 'خارج'),
      describeFlag(row?.bEligibleForBaseline, 'واجد شرایط تحلیل'),
      describeFlag(row?.bEligibleElectrical, 'واجد شرایط الکتریکی'),
      describeFlag(row?.bAnalyzed, 'تحلیل روزانه انجام شده'),
      describeFlag(row?.bSuspicious, 'علامت مشکوک'),
    ];
    if (typeof row?.fPowerChangeScore === 'number' && Number.isFinite(row.fPowerChangeScore)) {
      details.push(`امتیاز تغییر توان: ${row.fPowerChangeScore.toLocaleString('en-US', { maximumFractionDigits: 4 })}`);
    }
    return { ...item, details, warning: row?.bSuspicious === true || (row?.bSuspicious as unknown) === 1 };
  });
}

function describeFlag(value: unknown, label: string, yes = 'بله', no = 'خیر'): string {
  return `${label}: ${value === true || value === 1 ? yes : value === false || value === 0 ? no : 'نامشخص'}`;
}
